import { render, staticRenderFns } from "./ed-h1.vue?vue&type=template&id=24699430&scoped=true&"
import script from "./ed-h1.ts?vue&type=script&lang=js&"
export * from "./ed-h1.ts?vue&type=script&lang=js&"
import style0 from "./ed-h1.scss?vue&type=style&index=0&id=24699430&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24699430",
  null
  
)

export default component.exports